// src/env.d.ts
export { };

declare global {
  interface Window {
    env: {
      NX_API_BASE_URL: string;
      NX_MICROSOFT_CLIENT_ID: string;
      NX_TENANT_ID: string;
      NX_AZURE_API_SCOPE: string;
      // NX_WEBSOCKET_URL: string;
    };
  }
}
